import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DesktopOnlyModalComponent } from '@obo-common/shared/components/desktopOnlyModal/desktopOnlyModal.component';
import { ExtendedPlanning } from '@obo-dashboard/models/projectManagement.models';
import { ConfiguratorDetailBarComponent } from '@obo-dashboard/components/dashboard/project/configurator-detail-bar/configurator-detail-bar.component';
import { Constants } from '@obo-app/constants';
import { RestoreConfigurationService } from '@obo-main/services/configurator/restoreConfiguration.service';

@Component({
    selector: 'app-plannings',
    templateUrl: './plannings.component.html',
    styleUrls: ['./plannings.component.scss'],
    standalone: false
})
export class PlanningsComponent implements OnChanges, OnInit {
    @Input()
    public buildingId: number;
    @Input()
    public projectId: number;
    @Input()
    public plannings: ExtendedPlanning[];
    @Input()
    public isMobile: boolean = false;
    @Output()
    public reloadBuildings: EventEmitter<number> = new EventEmitter<number>();

    public plannedPlannings: ExtendedPlanning[] = [];
    public unplannedPlannings: ExtendedPlanning[] = [];
    protected drafts: ExtendedPlanning[] = [];
    public configurationTab: string;

    @ViewChild('desktopOnlyModalTpl')
    public desktopOnlyModal: DesktopOnlyModalComponent;
    @ViewChild(ConfiguratorDetailBarComponent)
    public detailBar: ConfiguratorDetailBarComponent;

    constructor(private restoreConfigurationService: RestoreConfigurationService) {}

    public ngOnInit(): void {
        this.setConfigurationTab();
    }

    public setConfigurationTab(): void {
        this.plannedPlannings.length > 0 ? (this.configurationTab = 'planned') : (this.configurationTab = 'unplanned');
    }

    public ngOnChanges(changes: SimpleChanges): void {
        this.plannedPlannings = this.plannings.filter((p) => p.isPlanned);
        this.unplannedPlannings = this.plannings.filter((p) => !p.isPlanned);
        this.drafts = this.getDraftsFromUnPlannedModules();
        if (this.plannedPlannings.length === 0) {
            this.setConfigurationTab();
        }

        if (changes.buildingId) {
            this.setConfigurationTab();
        }
    }

    public openWarningModal(): void {
        this.desktopOnlyModal.open();
    }

    public openDetails(planning: ExtendedPlanning, isDraft?: boolean): void {
        this.detailBar.toggleSidebar(planning, isDraft);
    }

    private getDraftsFromUnPlannedModules(): ExtendedPlanning[] {
        return this.unplannedPlannings.filter((planning: ExtendedPlanning) => {
            const storageKey = Constants.storageTokens[`${Constants.ModuleId[planning.moduleId].toLowerCase()}_configuration`];
            const isLocalStorageAvailable = this.restoreConfigurationService.isLocalStorageConfigurationAvailable(storageKey, {
                projectId: this.projectId,
                buildingId: this.buildingId
            });
            planning.infos = isLocalStorageAvailable.timeStamp;
            return isLocalStorageAvailable.value;
        });
    }
}
